import { http } from "@/http";

export const runStudy = async(id:string) => {
	const { data } = await http.post(`studies/${id}`);
	return data;
};